import BaseComponent from "@js/components/base_component.jsx";

class EuiDefaultBounceAddress extends BaseComponent {

  constructor(props) {
    super(props);

    this.state = {
      editing: false,
    };
  }

  render() {
    return (
      <Panel heading="default_bounce_address">
        <form
          method="POST"
          action={ Routes.update_default_bounce_address_eui_incoming_email_domains_path() }
        >
          <input type="hidden" name="_method" value="PUT" />
          <table className="table">
            <thead>
              <tr>
                <th style={{ width: "70%" }}>Bounce Address</th>
                <th />
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  { this._renderBounceAddress() }
                </td>
                <td className="index-buttons actions">
                  <input
                    type="hidden"
                    name="return_to"
                    value={ window.location.href }
                  />
                  <input
                    type="hidden"
                    name="authenticity_token"
                    value={ this.props.authenticity_token }
                  />

                  { this._renderButtons() }
                </td>
              </tr>
            </tbody>
          </table>
        </form>
      </Panel>
    );
  }

  _renderBounceAddress() {
    const hasBounceAddresses = this.props.library.bounce_addresses.data.length > 0;

    return this.state.editing ? (
      <SelectBounceAddress
        library={this.props.library}
        selected={this.props.default_bounce_address ? this.props.default_bounce_address.email : ""}
        name="default_bounce_address_email"
        showBlank={true}
        offerSystemDefault={false}
      />
    ) : (
      <div>
        {
          !this.props.default_bounce_address.email ? (
            hasBounceAddresses ? (
              <i>{ I18n.t("phrases.none_configured") }</i>
            ) : (
              <span>
                <i>{ I18n.t("phrases.none_configured") }</i> &mdash; { I18n.t("phrases.add_at_least_one_bounce_mailbox") }
              </span>
            )
          ) : ( this.props.default_bounce_address.domain_id && this.props.default_bounce_address.user_id ) ? (
            <a href={ Routes.eui_incoming_email_domain_domain_user_path(this.props.default_bounce_address.domain_id, this.props.default_bounce_address.user_id) }>
              { this.props.default_bounce_address.email }
            </a>
          ) : (
            this.props.default_bounce_address.email
          )
        }
      </div>
    );
  }

  _renderButtons() {
    const allowEdit = this.props.library.system_configuration.allow_edit_incoming_email_domains;
    const hasBounceAddresses = this.props.library.bounce_addresses.data.length > 0;

    return this.props.hide_editing ? null : this.state.editing ? (
      <div>
        <ButtonCancel onClick={this._onCancelClicked} />
        <ButtonSave onClick={this._onSaveClicked} />
      </div>
    ) : allowEdit && hasBounceAddresses ? (
      <div>
        <ButtonEdit onClick={this._onEditClicked} size="small" />
      </div>
    ) : (
      <div>
      </div>
    );
  }

  _onCancelClicked(e) {
    e.stopPropagation();
    e.preventDefault();

    this.setState({ editing: false });
  }

  _onSaveClicked(e) {
    e.stopPropagation();
    e.preventDefault();
  }

  _onEditClicked(e) {
    e.stopPropagation();
    e.preventDefault();

    this.setState({ editing: true });
  }

}

export default EuiDefaultBounceAddress;
